import { pgTable, uuid, text, boolean, integer, jsonb, timestamp, uniqueIndex } from "drizzle-orm/pg-core";

const tz = { withTimezone: true } as const;

/**
 * Per-tenant MCP and AI discovery settings.
 * Controls what data is exposed to AI agents and how they can interact.
 * One row per tenant (UNIQUE on tenant_id).
 * All defaults are safe (MCP disabled, pricing shown, human confirmation required).
 */
export const tenantMcpSettings = pgTable("tenant_mcp_settings", {
  id: uuid("id").primaryKey().defaultRandom(),
  tenantId: uuid("tenant_id").notNull(),
  mcpCustomerEnabled: boolean("mcp_customer_enabled").notNull().default(false),
  showPricing: boolean("show_pricing").notNull().default(true),
  showCreditPackages: boolean("show_credit_packages").notNull().default(false),
  maxAiBookingsPerDay: integer("max_ai_bookings_per_day").notNull().default(10),
  requireHumanConfirmation: boolean("require_human_confirmation").notNull().default(true),
  coarseAvailabilityOnly: boolean("coarse_availability_only").notNull().default(true),
  allowedTools: text("allowed_tools").array(),
  businessDescription: text("business_description"),
  businessHours: jsonb("business_hours"),
  disabledAt: timestamp("disabled_at", tz),
  createdAt: timestamp("created_at", tz).notNull().defaultNow(),
  updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
}, (table) => [
  // Council condition: exactly one settings row per tenant
  uniqueIndex("idx_tenant_mcp_settings_tenant_unique").on(table.tenantId),
]);
